<p
  class="follow-artist-tip"
  *ngIf="followButtonData?.followTipTexts as followTipTexts"
  [translate]="isActive ? followTipTexts.on : followTipTexts.off"
></p>

<div
  class="follow-button"
  [attr.tabindex]="followButtonData?.readonly ? '-1' : '0'"
  tenTooltipPositionIndicator
  matTooltipPosition="above"
  matTooltipClass="follow-button-tooltip"
  (accessibleClick)="togglePreference($event)"
  [matTooltipDisabled]="!followButtonData?.toolTipTexts"
  [matTooltip]="(isActive ? followButtonData?.toolTipTexts?.on : followButtonData?.toolTipTexts?.off) | translate"
  [attr.aria-label]="isActive | followButtonAriaLabel: followButtonData?.favourite"
  [attr.role]="'button'"
  [attr.aria-hidden]="followButtonData?.readonly"
  [class.disabled]="followButtonData?.readonly"
  [class.following]="isActive"
  [ngClass]="followButtonData?.style"
  [class.favourite]="followButtonData?.favourite"
>
  <ten-follow-icons
    class="follow-button__icon"
    [isActive]="isActive"
    [type]="followButtonData?.favourite ? 'favorite' : 'follow'"
  ></ten-follow-icons>

  <div
    *ngIf="followButtonData?.texts as texts"
    class="follow-button__text"
    [translate]="isActive ? texts.on : texts.off"
  ></div>
</div>
